import { isMenuItem } from "../../../components/MenuItem";
export function isActiveElement(element) {
  return isMenuItem(element) && !element.props.disabled;
}